import config from 'client/config'
import axios from 'axios'

const updateLastLoggedInTime = async (user, idToken) => {
  try {
    const { instance_id: instanceId } = user
    const euProd = typeof (instanceId) === 'string' && instanceId.toLowerCase() === 'eu1'
    const uri = euProd ? config.euApiUri : config.apiUri
    if (!uri) {
      return { success: false }
    }
    await axios.patch(`${uri}/users/${user.id}`, {
      update_last_login: true,
      user,
      user_id: user.id,
      login_id: user.user_id,
      organization_id: user.organization_id
    }, { headers: { Authorization: `Bearer ${idToken}` } })
    return { success: true }
  } catch (error) {
    console.log('err in updateLastLoggedInTime')
    console.error(error)
    return { success: false }
  }
}

export default {
  updateLastLoggedInTime
}
